<template>
<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
  <path fill="currentColor" d="M 8.572 20.931 L 0 12.359 L 2.417 9.943 L 8.572 16.08 L 21.583 3.068 L 24 5.502 L 8.572 20.931 Z"></path>
</svg>
</template>
